<template>
  <div class="evento-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Evento">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="eventoDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Configuración del Evento">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="eventoConfiguracion" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="tieneCamposAdicionales">
      <b-col cols="12" xl="12">  
        <b-card header="Campos Adicionales">
          <b-table 
              class="registro campos-adicionales" 
              responsive="sm" 
              :items="camposAdicionales" 
              :fields="camposAdicionalesFields">
            <template v-slot:cell(obligatorio)="data">
              {{ data.item.obligatorio ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(incluirListado)="data">
              {{ data.item.incluirListado ? 'Si' : 'No' }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="tieneTiendas">
      <b-col cols="12" xl="12">  
        <b-card header="Tiendas">
          <b-table 
              class="registro tiendas" 
              responsive="sm" 
              :items="tiendas" 
              :fields="tiendasFields">
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="tieneProductos">
      <b-col cols="12" xl="12">  
        <b-card header="Productos">
          <b-table 
              class="registro productos" 
              responsive="sm" 
              :items="productos" 
              :fields="productosFields">
            <template v-slot:cell(requiereInformacionAdicional)="data">
              {{ data.item.requiereInformacionAdicional ? 'Si' : 'No' }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn" v-if="!accesoABM | sorteado">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <div class="fixed-btn" v-if="accesoABM & !sorteado">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editarEvento">
            <i class="fa fa-edit"></i>Editar Datos del Evento</b-dropdown-item>
          
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventoDatos/getField',
  mutationType: 'eventoDatos/updateField',
});

export default {
  name: 'EventoDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      eventoId: 0,
      
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      camposAdicionalesFields: [
        { key: 'campo' },
        { 
          key: 'obligatorio',
          label: 'Requerido',
          class: 'text-center' 
        },
        { 
          key: 'incluirListado',
          label: 'Listado Participantes',
          class: 'text-center' 
        }
      ],

      tiendasFields: [
        { key: 'nombre' },
      ],

      productosFields: [
        { key: 'nombre' },
        { key: 'marca' },
        { 
          key: 'ean',
          label: 'EAN' 
        },
        { 
          key: 'requiereInformacionAdicional',
          label: 'Req.Info Adicional',
          class: 'text-center' 
        },
      ],

      accesoABM: false
    }
  },
  computed: {
    ...mapFields([
      'eventoDatos',
      'eventoConfiguracion',
      'camposAdicionales',
      'productos',
      'tiendas',
      'sorteado'
    ]),
    tieneCamposAdicionales() {
      if (this.camposAdicionales) {
        if (this.camposAdicionales.length != 0) {
          return true;
        }
      }
      return false;
    },
    tieneTiendas() {
      if (this.tiendas) {
        if (this.tiendas.length != 0) {
          return true;
        }
      }
      return false;
    },
    tieneProductos() {
      if (this.productos) {
        if (this.productos.length != 0) {
          return true;
        }
      }
      return false;
    }
  },
  created() {
    if ((/true/i).test(this.$store.getters['user/admin'])) {
      this.accesoABM = true;
    }

    this.eventoId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('eventoDatos/getDatos', this.eventoId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    editarEvento() {
      this.$router.push({ name: 'EventoEdit', 
                          params: { id: this.eventoId }});
    },
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .evento-datos .registro.campos-adicionales table td[aria-colindex="1"] {
    width: 70%;
  }
  .evento-datos .registro.campos-adicionales table td[aria-colindex="2"] {
    width: 15%;
  }
  .evento-datos .registro.campos-adicionales table td[aria-colindex="3"] {
    width: 15%;
  }

  .evento-datos .registro.productos table td[aria-colindex="1"] {
    width: 40%;
  }
  .evento-datos .registro.productos table td[aria-colindex="2"] {
    width: 35%;
  }
  .evento-datos .registro.productos table td[aria-colindex="3"] {
    width: 10%;
  }
  .evento-datos .registro.productos table td[aria-colindex="4"] {
    width: 15%;
  }
</style>